import { operationsClient } from 'packages/lib/api/annotations-ops/http-client';
import {
  TaskHistoryEventPost,
  TaskHistoryEventSchema,
  PickupStrategy,
  PickupStrategiesMap,
  pickupStrategiesMapZod,
} from 'packages/lib/api/annotations-ops/contract';
import { PickupTaskResponseSchema } from 'packages/lib/api/annotations-ops/contract/pickup-task-response';

export const pickupStrategyUri = (sampleGroupToken: string) =>
  `/task-management/pickup-strategies/${sampleGroupToken}`;

export const taskManApi = {
  history: {
    get: (userEmail: string, taskToken?: string) => {
      return operationsClient.get(
        `/task-management/history?userEmail=${userEmail}${
          taskToken ? `&taskToken=${taskToken}` : ''
        }`,
        {
          schema: TaskHistoryEventSchema.array(),
        }
      );
    },
    post: (body: TaskHistoryEventPost) => {
      return operationsClient.post('/task-management/history', {
        body,
      });
    },
  },
  queue: {
    pickup: (
      objectToken: string,
      taskGroupToken: string,
      userEmail: string
    ) => {
      return operationsClient.post(
        `/task-management/queue/pickup-by-object-token/${objectToken}?task_group_token=${taskGroupToken}&user_email=${userEmail}`,
        {
          schema: PickupTaskResponseSchema,
        }
      );
    },
    getPickupStrategies: (
      sampleGroupToken: string
    ): Promise<PickupStrategiesMap> =>
      operationsClient.get(pickupStrategyUri(sampleGroupToken), {
        schema: pickupStrategiesMapZod,
      }),
    updatePickupStrategy: async (
      sampleGroupToken: string,
      strategy: PickupStrategy
    ): Promise<PickupStrategiesMap> => {
      const updated = await operationsClient.put(
        pickupStrategyUri(sampleGroupToken),
        {
          body: strategy,
          schema: pickupStrategiesMapZod,
        }
      );

      if (!updated) {
        throw new Error('Failed to update pickup strategy');
      }

      return updated;
    },
  },
};
